import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { EventManagerNavigation } from '@components/event-manager-navigation';
import { LAYOUT_DEFAULT, LAYOUT_EMPTY, LAYOUT_EVENT, LAYOUT_WITHOUT_SIDEBAR } from '@contexts/layout/layout.type';
import { LayoutContext } from '@contexts/layout/layout-context';

import { LayoutDefault } from './components/layout-default';
import { Props } from './layout.types';

const LayoutEvents = ({ children }: Props) => {
  const navigate = useNavigate();
  return <EventManagerNavigation navigateTo={navigate}>{children}</EventManagerNavigation>;
};

const LayoutWithoutSidebar = ({ children }: Props) => {
  return (
    <div className='bg-primary'>
      <div className='max-w-7xl mx-auto pt-8 md:pt-14 px-4'>{children}</div>
    </div>
  );
};

const LayoutEmpty = ({ children }: Props) => {
  return <div className='max-w-[850px] mx-auto px-4 lg:px-0 min-h-screen pt-8 md:pt-14 pb-10'>{children}</div>;
};

export const Layout = ({ children }: Props) => {
  const { layoutType } = useContext(LayoutContext);

  if (layoutType === LAYOUT_DEFAULT) {
    return <LayoutDefault>{children}</LayoutDefault>;
  }

  if (layoutType === LAYOUT_EVENT) {
    return <LayoutEvents>{children}</LayoutEvents>;
  }
  if (layoutType === LAYOUT_WITHOUT_SIDEBAR) {
    return <LayoutWithoutSidebar>{children}</LayoutWithoutSidebar>;
  }
  if (layoutType === LAYOUT_EMPTY) {
    return <LayoutEmpty>{children}</LayoutEmpty>;
  }

  return <>{children}</>;
};
